import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import FlagIcon from 'vue-flag-icon';
import pdfvuer from 'pdfvuer';
import VueInputMask from "vue-inputmask";
import VueTheMask from 'vue-the-mask';
import VueSimpleAlert from "vue-simple-alert";
import './registerServiceWorker';
import './assets/scss/app.scss';
import '@/assets/css/app.css';
import '@/assets/css/materialdesignicons.min.css';

import 'bulma-modal-fx/dist/css/modal-fx.min.css';
import 'material-icons/iconfont/material-icons.css';
import 'bulma-badge/dist/css/bulma-badge.min.css';

import './globalplugins';
import './globalcomponents';
import './globalFilters';
import './globalDirectives';
import VueCurrencyInput from 'vue-currency-input'
import VueExcelXlsx from "vue-excel-xlsx";
//AvatarCropper
import AvatarCropper from "vue-avatar-cropper";

Vue.component("avatar-cropper", AvatarCropper);
Vue.component('pdf', pdfvuer);
Vue.component('vueMask', VueInputMask);
Vue.use(VueCurrencyInput)

// QuillEditor
import VueQuillEditor from "vue-quill-editor";
import './assets/katex/katex.min.js';
import { ImageResize } from './assets/quill-image-resize-module/image-resize.min.js';

// require styles
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import "katex/dist/katex.css";
import "quill-better-table/dist/quill-better-table.css";
import "quill/dist/quill.snow.css";

Vue.use(VueQuillEditor)
Vue.use(FlagIcon);
Vue.use(VueTheMask)
Vue.use(VueSimpleAlert);
Vue.use(VueExcelXlsx);

import 'moment-countdown/dist/moment-countdown.js';

import myMSALObj from './config/azure-b2c/settings';
Vue.prototype.$authService = myMSALObj;

import Axios from "axios";

Vue.prototype.$http = Axios;

export var bus = new Vue();


Vue.config.productionTip = false;

let endpointCallOrder = 0;

Axios.interceptors.request.use((request: any) => {
  endpointCallOrder += 1;
  request.endpointCallOrder = endpointCallOrder;

  const method = request.method ? request.method.toUpperCase() : "GET";
  const baseUrl = request.baseURL || "";
  const url = request.url || "";

  console.log(
    `[Endpoint #${endpointCallOrder}] ${method} ${baseUrl}${url}`,
    {
      data: request.data,
      params: request.params,
    }
  );

  return request;
});

Axios.interceptors.response.use(
  (response: any) => {
    const request = response.config || {};
    const order = request.endpointCallOrder || "?";
    const method = request.method ? request.method.toUpperCase() : "GET";
    const baseUrl = request.baseURL || "";
    const url = request.url || "";

    console.log(
      `[Endpoint #${order}] ${response.status} ${method} ${baseUrl}${url}`,
      response.data
    );

    return response;
  },
  (error: any) => {
    const request = error.config || {};
    const response = error.response || {};
    const order = request.endpointCallOrder || "?";
    const method = request.method ? request.method.toUpperCase() : "GET";
    const baseUrl = request.baseURL || "";
    const url = request.url || "";
    const status = response.status || "ERROR";

    console.error(
      `[Endpoint #${order}] ${status} ${method} ${baseUrl}${url}`,
      response.data || error
    );

    return Promise.reject(error);
  }
);

// filters
import moment from "moment";

Vue.filter('LLLL', (value: any) => {
  if (!value) return ''
  return moment(value).format('LLLL');
});

router.beforeEach((to, from, next) => {
  const redirectToInicio = () => {
    if (to.path === "/inicio") {
      next();
      return;
    }

    next("/inicio");
  };

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (!requiresAuth) {
    next();
    return;
  }

  const isLoggedIn = store.getters.isLoggedIn;

  if (!isLoggedIn) {
    redirectToInicio();
    return;
  }

  const userRaw = localStorage.getItem("user");

  if (!userRaw) {
    redirectToInicio();
    return;
  }

  let user: any;

  try {
    user = JSON.parse(userRaw);
  } catch {
    redirectToInicio();
    return;
  }

  const permission = to.meta.permissionValue;
  const permissions = Array.isArray(user.permissions) ? user.permissions : [];

  const hasPermission =
    user.isAdmin ||
    !permission ||
    permissions.some((x: any) => x.permissionValue === permission);

  if (hasPermission) {
    next();
    return;
  }

  redirectToInicio();
});

import i18n from '@/Plugin/i18n';
window.onload = () => {
  new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
  }).$mount('#app');
};



